/**
 * LCC Shipping Selector
 * - Selector de Región / Comuna en el carrito lateral y página de carrito
 * - Siempre inicia vacío (sessionStorage: se limpia al cerrar la pestaña)
 * - Pre-rellena el checkout con la región y comuna seleccionadas
 * - Completamente independiente de la página de producto
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lcc_envio';

  // ============================================================
  // DATOS: TODAS LAS REGIONES Y COMUNAS DE CHILE
  // ============================================================
  var REGIONES = [
    {
      id: 'arica',
      shopify: 'Arica y Parinacota',
      nombre: 'Región de Arica y Parinacota',
      comunas: ['Arica', 'Camarones', 'General Lagos', 'Putre'],
    },
    {
      id: 'tarapaca',
      shopify: 'Tarapacá',
      nombre: 'Región de Tarapacá',
      comunas: ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'],
    },
    {
      id: 'antofagasta',
      shopify: 'Antofagasta',
      nombre: 'Región de Antofagasta',
      comunas: [
        'Antofagasta', 'Calama', 'María Elena', 'Mejillones', 'Ollagüe',
        'San Pedro de Atacama', 'Sierra Gorda', 'Taltal', 'Tocopilla',
      ],
    },
    {
      id: 'atacama',
      shopify: 'Atacama',
      nombre: 'Región de Atacama',
      comunas: [
        'Alto del Carmen', 'Caldera', 'Chañaral', 'Copiapó', 'Diego de Almagro',
        'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar',
      ],
    },
    {
      id: 'coquimbo',
      shopify: 'Coquimbo',
      nombre: 'Región de Coquimbo',
      comunas: [
        'Andacollo', 'Canela', 'Combarbalá', 'Coquimbo', 'Illapel', 'La Higuera',
        'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paihuano',
        'Río Hurtado', 'Salamanca', 'Vicuña',
      ],
    },
    {
      id: 'valparaiso',
      shopify: 'Valparaíso',
      nombre: 'Región de Valparaíso',
      comunas: [
        'Algarrobo', 'Cabildo', 'Calera', 'Calle Larga', 'Cartagena', 'Casablanca',
        'Catemu', 'Concón', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua',
        'Juan Fernández', 'La Cruz', 'La Ligua', 'Limache', 'Llaillay', 'Los Andes',
        'Nogales', 'Olmué', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncaví',
        'Putaendo', 'Quillota', 'Quilpué', 'Quintero', 'Rinconada', 'San Antonio',
        'San Esteban', 'San Felipe', 'Santa María', 'Santo Domingo', 'Valparaíso',
        'Villa Alemana', 'Viña del Mar', 'Zapallar',
      ],
    },
    {
      id: 'metropolitana',
      shopify: 'Metropolitana de Santiago',
      nombre: 'Región Metropolitana de Santiago',
      comunas: [
        'Alhué', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina',
        'Conchalí', 'Curacaví', 'El Bosque', 'El Monte', 'Estación Central',
        'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida',
        'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea',
        'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'María Pinto', 'Melipilla',
        'Ñuñoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Peñaflor',
        'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura',
        'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín',
        'San José de Maipo', 'San Miguel', 'San Pedro', 'San Ramón', 'Santiago',
        'Talagante', 'Tiltil', 'Vitacura',
      ],
    },
    {
      id: 'ohiggins',
      shopify: "Libertador General Bernardo O'Higgins",
      nombre: "Región del Libertador General Bernardo O'Higgins",
      comunas: [
        'Chimbarongo', 'Chépica', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue',
        'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machalí',
        'Malloa', 'Marchihue', 'Nancagua', 'Navidad', 'Olivar', 'Palmilla',
        'Paredones', 'Peralillo', 'Peumo', 'Pichidegua', 'Pichilemu', 'Placilla',
        'Pumanque', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa',
        'San Fernando', 'San Vicente', 'Santa Cruz',
      ],
    },
    {
      id: 'maule',
      shopify: 'Maule',
      nombre: 'Región del Maule',
      comunas: [
        'Cauquenes', 'Chanco', 'Colbún', 'Constitución', 'Curepto', 'Curicó',
        'Empedrado', 'Hualañé', 'Licantén', 'Linares', 'Longaví', 'Maule', 'Molina',
        'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro', 'Río Claro',
        'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier', 'San Rafael',
        'Talca', 'Teno', 'Vichuquén', 'Villa Alegre', 'Yerbas Buenas',
      ],
    },
    {
      id: 'nuble',
      shopify: 'Ñuble',
      nombre: 'Región de Ñuble',
      comunas: [
        'Bulnes', 'Chillán', 'Chillán Viejo', 'Cobquecura', 'Coelemu', 'Coihueco',
        'El Carmen', 'Ninhue', 'Ñiquén', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillón',
        'Quirihue', 'Ránquil', 'San Carlos', 'San Fabián', 'San Ignacio',
        'San Nicolás', 'Trehuaco', 'Yungay',
      ],
    },
    {
      id: 'biobio',
      shopify: 'Biobío',
      nombre: 'Región del Biobío',
      comunas: [
        'Alto Biobío', 'Antuco', 'Arauco', 'Cabrero', 'Cañete', 'Chiguayante',
        'Concepción', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpén',
        'Hualqui', 'Laja', 'Lebu', 'Los Álamos', 'Los Ángeles', 'Lota', 'Mulchén',
        'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco',
        'San Pedro de la Paz', 'San Rosendo', 'Santa Bárbara', 'Santa Juana',
        'Talcahuano', 'Tirúa', 'Tomé', 'Tucapel', 'Yumbel',
      ],
    },
    {
      id: 'araucania',
      shopify: 'La Araucanía',
      nombre: 'Región de La Araucanía',
      comunas: [
        'Angol', 'Carahue', 'Cholchol', 'Collipulli', 'Cunco', 'Curacautín',
        'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro',
        'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco',
        'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón',
        'Purén', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén',
        'Traiguén', 'Victoria', 'Vilcún', 'Villarrica',
      ],
    },
    {
      id: 'losrios',
      shopify: 'Los Ríos',
      nombre: 'Región de Los Ríos',
      comunas: [
        'Corral', 'Futrono', 'La Unión', 'Lago Ranco', 'Lanco', 'Los Lagos',
        'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia',
      ],
    },
    {
      id: 'loslagos',
      shopify: 'Los Lagos',
      nombre: 'Región de Los Lagos',
      comunas: [
        'Ancud', 'Calbuco', 'Castro', 'Chaitén', 'Chonchi', 'Cochamó',
        'Curaco de Vélez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufú',
        'Hualaihué', 'Llanquihue', 'Los Muermos', 'Maullín', 'Osorno', 'Palena',
        'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldón', 'Purranque',
        'Puyehue', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao',
        'Río Negro', 'San Juan de la Costa', 'San Pablo',
      ],
    },
    {
      id: 'aysen',
      shopify: 'Aysén del General Carlos Ibáñez del Campo',
      nombre: 'Región de Aysén del Gral. Carlos Ibáñez del Campo',
      comunas: [
        'Aysén', 'Chile Chico', 'Cisnes', 'Cochrane', 'Coyhaique', 'Guaitecas',
        'Lago Verde', "O'Higgins", 'Río Ibáñez', 'Tortel',
      ],
    },
    {
      id: 'magallanes',
      shopify: 'Magallanes y la Antártica',
      nombre: 'Región de Magallanes y de la Antártica Chilena',
      comunas: [
        'Antártica', 'Cabo de Hornos', 'Laguna Blanca', 'Natales',
        'Punta Arenas', 'Río Verde', 'San Gregorio', 'Timaukel', 'Torres del Paine',
      ],
    },
  ];

  // ============================================================
  // STORAGE — sessionStorage: vacío en cada nueva visita/pestaña
  // ============================================================
  function save(regionId, shopifyRegion, regionNombre, comuna) {
    var current = load();
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        regionId:      regionId,
        shopifyRegion: shopifyRegion,
        regionNombre:  regionNombre,
        comuna:        comuna,
        pickup:        current.pickup || false,
      }));
    } catch (_) {}
  }

  function savePickup(isPickup) {
    var current = load();
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        regionId:      current.regionId      || '',
        shopifyRegion: current.shopifyRegion || '',
        regionNombre:  current.regionNombre  || '',
        comuna:        current.comuna        || '',
        pickup:        !!isPickup,
      }));
    } catch (_) {}
  }

  function load() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; }
    catch (_) { return {}; }
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function findRegion(id) {
    return REGIONES.find(function (r) { return r.id === id; }) || null;
  }

  function populateComunas(select, regionId) {
    var region = findRegion(regionId);
    select.innerHTML = '';
    if (!region) {
      select.innerHTML = '<option value="">Selecciona región primero</option>';
      select.disabled = true;
      return;
    }
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Selecciona tu comuna…';
    select.appendChild(placeholder);
    region.comunas.forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      select.appendChild(opt);
    });
    select.disabled = false;
  }

  function buildCheckoutUrl(shopifyRegion, comuna) {
    var url = new URL('/checkout', window.location.origin);
    url.searchParams.set('checkout[shipping_address][country]',  'Chile');
    url.searchParams.set('checkout[shipping_address][province]', shopifyRegion);
    url.searchParams.set('checkout[shipping_address][city]',     comuna);
    return url.toString();
  }

  function updateCartAttributes(regionNombre, comuna) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Región de envío': regionNombre, 'Comuna de envío': comuna },
      }),
    }).catch(function () {});
  }

  function updateUI(regionId, comuna, warningEl, confirmEl, confirmTx) {
    var complete = !!(regionId && comuna);
    if (warningEl) warningEl.classList.toggle('is-visible', !complete);
    if (confirmEl) {
      confirmEl.classList.toggle('is-visible', complete);
      if (complete && confirmTx) {
        var r = findRegion(regionId);
        if (r) confirmTx.textContent = r.nombre + ' – ' + comuna;
      }
    }
  }

  // ============================================================
  // BLOQUEAR / DESBLOQUEAR BOTÓN CHECKOUT
  // force=true desbloquea sin importar si tiene data-lcc-blocked
  // ============================================================
  function setBlocked(blocked, force) {
    ['CartDrawer-Checkout', 'checkout'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-lcc-blocked', 'true');
      } else if (force || btn.getAttribute('data-lcc-blocked') === 'true') {
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-lcc-blocked');
      }
    });
  }

  // ============================================================
  // INICIALIZAR UN SELECTOR (drawer o página de carrito)
  // Usa referencias _lccChange / _lccClick para limpiar listeners
  // sin modificar el DOM (evita el bucle MutationObserver).
  // ============================================================
  function initSelector(cfg) {
    var regionEl  = document.getElementById(cfg.idRegion);
    var comunaEl  = document.getElementById(cfg.idComuna);
    var warningEl = document.getElementById(cfg.idWarning);
    var confirmEl = document.getElementById(cfg.idConfirm);
    var confirmTx = document.getElementById(cfg.idConfirmText);
    var checkBtn  = document.getElementById(cfg.idCheckout);
    var pickupEl  = document.getElementById(cfg.idPickup);
    var fieldsEl  = document.getElementById(cfg.idFields);

    if (!regionEl || !comunaEl) return;

    // Poblar regiones (solo si el select está vacío)
    if (regionEl.options.length <= 1) {
      REGIONES.forEach(function (r) {
        var opt = document.createElement('option');
        opt.value = r.id;
        opt.textContent = r.nombre;
        regionEl.appendChild(opt);
      });
    }

    // Restaurar estado de la sesión actual
    var saved = load();

    if (saved.pickup) {
      // Modo retiro en local
      if (pickupEl)  pickupEl.checked = true;
      if (fieldsEl)  fieldsEl.classList.add('lcc-ship__fields--hidden');
      if (warningEl) warningEl.classList.remove('is-visible');
      if (confirmEl) confirmEl.classList.remove('is-visible');
      setBlocked(false, true); // force: desbloquear aunque no tenga data-lcc-blocked
    } else {
      // Modo envío a domicilio
      if (pickupEl)  pickupEl.checked = false;
      if (fieldsEl)  fieldsEl.classList.remove('lcc-ship__fields--hidden');
      if (saved.regionId) {
        regionEl.value = saved.regionId;
        populateComunas(comunaEl, saved.regionId);
        if (saved.comuna) comunaEl.value = saved.comuna;
      }
      updateUI(saved.regionId || '', saved.comuna || '', warningEl, confirmEl, confirmTx);
      setBlocked(!(saved.regionId && saved.comuna));
    }

    // Eliminar listeners anteriores
    if (pickupEl  && pickupEl._lccChange)  pickupEl.removeEventListener('change',  pickupEl._lccChange);
    if (regionEl._lccChange)               regionEl.removeEventListener('change',  regionEl._lccChange);
    if (comunaEl._lccChange)               comunaEl.removeEventListener('change',  comunaEl._lccChange);
    if (checkBtn  && checkBtn._lccClick)   checkBtn.removeEventListener('click',   checkBtn._lccClick, true);

    // Handler: checkbox "Retiro en local"
    // Usa búsqueda dinámica para garantizar referencia al DOM actual
    if (pickupEl) {
      pickupEl._lccChange = function () {
        var checked = pickupEl.checked;
        savePickup(checked);
        // Buscar elementos dinámicamente (el drawer puede re-renderizarse)
        var fEl = document.getElementById(cfg.idFields);
        var wEl = document.getElementById(cfg.idWarning);
        var cEl = document.getElementById(cfg.idConfirm);
        if (checked) {
          if (fEl) fEl.classList.add('lcc-ship__fields--hidden');
          if (wEl) wEl.classList.remove('is-visible');
          if (cEl) cEl.classList.remove('is-visible');
          setBlocked(false, true); // force
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Método de entrega': 'Retiro en local', 'Región de envío': '', 'Comuna de envío': '' } }),
          }).catch(function () {});
        } else {
          if (fEl) fEl.classList.remove('lcc-ship__fields--hidden');
          var s = load();
          if (wEl && cEl) updateUI(s.regionId || '', s.comuna || '', wEl, cEl, document.getElementById(cfg.idConfirmText));
          setBlocked(!(s.regionId && s.comuna));
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Método de entrega': '' } }),
          }).catch(function () {});
        }
      };
      pickupEl.addEventListener('change', pickupEl._lccChange);
    }

    // Handler: cambia la región
    regionEl._lccChange = function () {
      var regionId = regionEl.value;
      populateComunas(comunaEl, regionId);
      if (regionId) {
        var r = findRegion(regionId);
        save(regionId, r.shopify, r.nombre, '');
      } else {
        save('', '', '', '');
      }
      updateUI(regionId, '', warningEl, confirmEl, confirmTx);
      setBlocked(true);
    };

    // Handler: cambia la comuna
    comunaEl._lccChange = function () {
      var regionId = regionEl.value;
      var comuna   = comunaEl.value;
      var r        = findRegion(regionId);
      if (!r) return;
      save(regionId, r.shopify, r.nombre, comuna);
      updateUI(regionId, comuna, warningEl, confirmEl, confirmTx);
      setBlocked(!comuna);
      if (comuna) updateCartAttributes(r.nombre, comuna);
    };

    regionEl.addEventListener('change', regionEl._lccChange);
    comunaEl.addEventListener('change', comunaEl._lccChange);

    // Handler: clic en botón de pago
    if (checkBtn) {
      checkBtn._lccClick = function (e) {
        var data = load();
        // Retiro en local: ir directo a checkout sin pre-llenar dirección
        if (data.pickup) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = '/checkout';
          return;
        }
        // Envío: verificar que haya región y comuna
        if (!data.shopifyRegion || !data.comuna) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var shakeEl = document.querySelector(cfg.selectorShake);
          if (shakeEl) {
            shakeEl.classList.remove('lcc-ship--shake');
            void shakeEl.offsetWidth;
            shakeEl.classList.add('lcc-ship--shake');
          }
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = buildCheckoutUrl(data.shopifyRegion, data.comuna);
      };
      checkBtn.addEventListener('click', checkBtn._lccClick, true);
    }
  }

  // ============================================================
  // INICIALIZAR CARRITO LATERAL
  // ============================================================
  function initDrawer() {
    initSelector({
      idRegion:      'lcc-region',
      idComuna:      'lcc-comuna',
      idWarning:     'lcc-ship-warning',
      idConfirm:     'lcc-ship-confirm',
      idConfirmText: 'lcc-ship-confirm-text',
      idCheckout:    'CartDrawer-Checkout',
      selectorShake: '.lcc-ship:not(.lcc-ship--page)',
      idPickup:      'lcc-pickup',
      idFields:      'lcc-ship-fields',
    });
  }

  // ============================================================
  // INICIALIZAR PÁGINA DE CARRITO (/cart)
  // ============================================================
  function initPage() {
    initSelector({
      idRegion:      'lcc-region-page',
      idComuna:      'lcc-comuna-page',
      idWarning:     'lcc-ship-warning-page',
      idConfirm:     'lcc-ship-confirm-page',
      idConfirmText: 'lcc-ship-confirm-text-page',
      idCheckout:    'checkout',
      selectorShake: '.lcc-ship--page',
      idPickup:      'lcc-pickup-page',
      idFields:      'lcc-ship-fields-page',
    });
  }

  // ============================================================
  // WATCH: re-inicializar cuando Shopify re-renderiza el drawer
  // ============================================================
  function watchDrawerRerenders() {
    // Al abrir el drawer: varios intentos para cubrir renders lentos
    document.addEventListener('cart-drawer:open', function () {
      setTimeout(initDrawer, 100);
      setTimeout(initDrawer, 400);
    });

    // MutationObserver en #CartDrawer (siempre en el DOM, incluso con carrito vacío).
    // .drawer__footer puede no existir en la primera carga.
    // Solo re-inicializa si nuestro selector no tiene listener (Shopify reemplazó el HTML).
    var container = document.getElementById('CartDrawer') ||
                    document.querySelector('[id*="CartDrawer"]') ||
                    document.querySelector('.cart-drawer');
    if (container) {
      new MutationObserver(function () {
        setTimeout(function () {
          var el = document.getElementById('lcc-region');
          if (el && !el._lccChange) initDrawer();
        }, 80);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  // ============================================================
  // ARRANQUE
  // ============================================================
  function setup() {
    initDrawer();
    initPage();
    watchDrawerRerenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

})();
